import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Sidebar/sgds-sidebar-group";
import { register } from "../../utils/ce-registry";

register("sgds-sidebar-group", Component);

export default createComponent({
  react: React,
  tagName: "sgds-sidebar-group",
  elementClass: Component,
  events: {}
});
